import type { AiMenuSource } from '@restaurant/api-contracts';

export interface MenuSourceFile {
  localId: string;
  kind: 'photo' | 'pdf';
  fileName: string;
  previewUrl: string | null;
  attachmentId: string | null;
}

export function buildMenuSources(files: MenuSourceFile[], link: string): AiMenuSource[] {
  const uploaded = files.flatMap((file): AiMenuSource[] =>
    file.attachmentId === null ? [] : [{ kind: file.kind, attachmentId: file.attachmentId }],
  );
  return link ? [...uploaded, { kind: 'url', url: link }] : uploaded;
}
